module.exports = __webpack_public_path__ + "media/images/icons/outlined/printer-e847e2bd94486430f01d38ce5ebcf0b1.svg";